import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbDatepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { DateSelectComponent } from "./date-select-basic/date-select.component";
import { DateSelectNoYearComponent } from './date-select-no-year/date-select-no-year.component';
import { DateSelectBase } from "./date-select.base";

@NgModule({
    declarations: [
        DateSelectComponent,
        DateSelectNoYearComponent,
        DateSelectBase
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbDatepickerModule
    ],
    exports: [
        DateSelectComponent,
        DateSelectNoYearComponent,
        DateSelectBase
    ]
})
export class DateSelectModule{}